"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InputNumber = _interopRequireDefault(require("./InputNumber"));
var _default = _InputNumber.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-input-number/lib/index.js
// module id = 941
// module chunks = 0